//
//
//
//
//
export default {
  name: 'App'
};